import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store, key } from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { i18n } from '@/i18n/index'
import '@/theme/index.scss'
import { globalComponentSize } from '@/utils/componentSize'
// import axios from 'axios'
import 'core-js/stable'
// createApp(App).use(store, key).use(router).use(ElementPlus).use(i18n).mount('#app')

// 统一导入el-icon图标
import * as ElIconModules from '@element-plus/icons'

const app = createApp(App)
app
  .use(router)
  .use(store, key)
  .use(ElementPlus, { i18n: i18n.global.t, size: globalComponentSize })
  .use(i18n)
  .mount('#app')

// console.log(process.env.VUE_APP_BASE_API)

// axios.get('/config.json').then((res) => {
//   const apiurl = JSON.parse(JSON.stringify(res.data)).apiurl
//   axios.defaults.baseURL = apiurl
// })

// axios.defaults.baseURL = 'http://localhost:5000/'
// 统一注册el-icon图标
for (const iconName in ElIconModules) {
  app.component(transElIconName(iconName), ElIconModules[iconName])
}

// utils/utils.js
// 将el-icon的组件名称AbbbCddd转化为i-abbb-cddd形式
// 此前用switch做组件名时因关键字重复报错，所以格式统一加了前缀
// 例：Switch转换为i-switch，ArrowDownBold转换为i-arrow-down-bold
function transElIconName (iconName:any) {
  return 'i' + iconName.replace(/[A-Z]/g, (match:any) => '-' + match.toLowerCase())
}
